import React, { Component } from 'react';
import SystemTranslationStatistic from './SystemTranslationStatistic';
import { browserHistory } from 'react-router';
import { observer } from 'mobx-react';
import SystemTranslationInstructionAudioStatisticService from '../services/SystemTranslationInstructionAudioStatisticService';

class SystemTranslationInstructionAudioStatisticContainer extends Component {
  systemTranslationInstructionAudioStatisticService = new SystemTranslationInstructionAudioStatisticService();

  componentDidMount() {
    this.systemTranslationInstructionAudioStatisticService.load();
  }

  render() {
    return (
      <SystemTranslationStatistic
        title="Instruction Audios"
        icon="customer-service"
        value={this.systemTranslationInstructionAudioStatisticService.summary}
        fetching={this.systemTranslationInstructionAudioStatisticService.fetch.fetching}
        onClick={() =>
          browserHistory.push({
            pathname: '/instruction-audios',
            state: { from: { text: 'System Translations', pathname: '/system-translations' } },
          })
        }
      />
    );
  }
}

export default observer(SystemTranslationInstructionAudioStatisticContainer);
